import React from "react";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import {Button, Modal} from "react-bootstrap";
import immutable from "immutable";
import moment from "moment";

import MessageDetail from "./message-detail.jsx";


export default class Announcement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {           
            showMore : false,
            items : [],
            messageDetail: null
        }

        this.loadItems = this.loadItems.bind(this);
    }

    componentDidMount() {
        this.loadItems(true);
    }

    loadItems(showAll) {  
        const self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });
        ajax.api()
            .get(`get-announcements/${showAll}`)
            .then(function(res) {
                context.message({show:false});

                if (res.data instanceof Array)
                    self.setState({items: res.data});
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    showMessageDetail(messageId, announcementId) {  
        const self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });
        ajax.api()
            .get(`get-message-detail/${messageId}/${announcementId}`)
            .then(function(res) {
                context.message({show:false});
                self.setState({messageDetail: res.data, showMore: true});
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    render() {         
        const visible = this.state.items.length > 0;
        const items = this.state.items;

        return (
            <div className={visible ? "ap-announcement-panel" : "ap-hidden"}>
                <h4 className="ap-announcement-panel-header body-text"><i className="fa fa-bullhorn fa-2"></i>Announcements</h4>
                <ul className="no-bullet">
                    {
                        items.map(item =>
                                <li>
                                    <i className="fa fa-lightbulb-o ap-announcement-icon"></i>
                                    <span>
                                        { item.header }
                                    </span>
                                    &nbsp;&nbsp;
                                    <a href="#" onClick={ ()=>this.showMessageDetail(item.messageId, item.announcementId) }>more <i className="fa fa-angle-double-right"></i></a>
                                </li>
                            )
                    }
                </ul>

                <Modal bsSize="lg" show={this.state.showMore} onHide={() => this.setState({showMore: false})}>
                    <Modal.Header closeButton={true}>
                        <Modal.Title>Details</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <MessageDetail vm={this.state.messageDetail} />
                    </Modal.Body>
                
                    <Modal.Footer>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-4">&nbsp;</div>
                                <div className="col-md-4">&nbsp;</div>
                                <div className="col-md-4">
                                    <Button className="ap-fullsize btn-info" onClick={() => this.setState({showMore: false})}>Close</Button>                                 
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}